<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col sm="6" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('manufacturing_movements.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="6" align="end" class="py-0">
                    <v-row class="py-0 px-0 my-0 mx-0" justify="end" align="end">
                        <v-btn class="right white_highlight--text tools-view-height mx-2" disabled color="secondary" @click="showExport = true">
                            {{ $t('manufacturing_movements.export_movements') }}
                        </v-btn>
                        <v-btn class="right white_highlight--text tools-view-height" disabled color="secondary" @click="showExport = true">
                            {{ $t('manufacturing_movements.export_settings') }}
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row class="px-5 pt-1 pb-5">
                            <v-col cols="12" align="center" justify="center">    
                                <h2 class="blue_accent--text text-uppercase">{{ $t('manufacturing_movements.movements') }} </h2>
                            </v-col>
                        </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text class="py-3">
                    <v-row class="px-5 pt-1 pb-5">
                            <v-col cols="12" align="center" justify="center">    
                                <h2 class="blue_accent--text text-uppercase">{{ $t('manufacturing_movements.settings') }} </h2>
                            </v-col>
                        </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers2, items: props2.items, search:props2.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="showExport" persistent max-width="90%" style="width: 500px !important;">
                <v-card style="width:500px !important">
                    <v-card-title class="justify-center mt-4">
                        <v-row align="center" justify="center" class="my-2">
                            <label style="font-size: 16px; font-weight: bold;" class="blue_accent--text text-uppercase">{{$t('manufacturing_movements.export_data')}}</label>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-0 my-0 text-center">
                            <v-col cols="6" class="py-0">
                                <datepicker :open_dialog="menu2" :model="report.initial_date" :label="$t('manufacturing_movements.initial_date')" @model="updateInitialDate($event)" :rules_required="rules_required"></datepicker>
                            </v-col>
                            <v-col cols="6" class="py-0">
                                <datepicker :open_dialog="menu3" :model="report.final_date" :label="$t('manufacturing_movements.final_date')" @model="updateFinalDate($event)" :rules_required="rules_required"></datepicker>
                            </v-col>
                        </v-row>
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="showExport = false">{{ $t('manufacturing_movements.cancel') }}</v-btn>
                            <v-btn color="secondary" class="white_highlight--text" @click="exportData">
                                {{ $t('manufacturing_movements.export') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
        </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('manufacturing_movements.id'), align: "center", value: 'id', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.sku'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.description'), align: "center", value: 'description', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.um'), align: "center", value: 'fa', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.quantity'), align: "center", value: 'umc', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.vu_dollars'), align: "center", value: 'umt', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.amount_dollars'), align: "center", value: 'umt', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.date'), align: "center", value: 'umt', class: 'text-uppercase' },
            ];
        },
        headers2(){
            return [
                { text: this.$t('manufacturing_movements.id'), align: "center", value: 'id', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.sku'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.description'), align: "center", value: 'description', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.um'), align: "center", value: 'fa', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.quantity'), align: "center", value: 'umc', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.vu_dollars'), align: "center", value: 'umt', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.amount_dollars'), align: "center", value: 'umt', class: 'text-uppercase' },
                { text: this.$t('manufacturing_movements.date'), align: "center", value: 'umt', class: 'text-uppercase' },
            ];
        }
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: [],
            },
            props2:{
                search: '',
                items: []
            },
            report:{
                initial_date: '',
                final_date: ''
            },
            menu2: false,
            menu3: false,
            showExport: false
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.manufacturing_movements";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        updateInitialDate(value){
            this.report.initial_date = value;
        },
        updateFinalDate(value){
            this.report.initial_date = value;
        },
        index(){
            // this.props.items = [];
            // this.$store.state.loaderProps.visible = true;
            // const lsToken = localStorage.getItem("access_token");
            // this.$http.get(this.$store.state.chronosApi + 'manufacturing_movements', {headers: {Authorization: lsToken}})
            // .then((response) => {
            //     console.log(response);
            // })
            // .catch((response) => {
            //     this.$store.state.loaderProps.visible = false;
            //     if(response.status !== 200){
            //         this.snackbar = {
            //             visible: true,
            //             color: 'red',
            //             text: this.$t('pendings.responses.error')
            //         }
            //     }
            // }).finally(() => {
            //     this.$store.state.loaderProps.visible = false;
            // });
        },
        exportData(){

        }
    }
}
</script>

<style>
</style>